import React from 'react';
import { BookOpen, Info } from 'lucide-react';

/**
 * Flashcard Creator Page (Teacher Feature)
 * Trang tạo flashcard cho giáo viên
 */
const FlashcardCreator: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-4xl mx-auto space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Tạo Flashcard</h1>
          <p className="text-gray-600 mt-2">Công cụ tạo thẻ ghi nhớ cho học sinh</p>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
          <div className="flex items-start space-x-3">
            <Info className="w-6 h-6 text-blue-600 mt-1" />
            <div>
              <p className="font-medium text-blue-900">Chức năng đang được phát triển</p>
              <p className="text-sm text-blue-700 mt-1">
                Công cụ tạo flashcard cho giáo viên sẽ được hoàn thiện trong phiên bản tiếp theo.
              </p>
              <div className="mt-3 text-sm text-blue-700">
                <p className="font-medium">Tính năng sẽ bao gồm:</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Tạo và chỉnh sửa flashcard với editor markdown</li>
                  <li>Hỗ trợ công thức toán học (KaTeX)</li>
                  <li>Upload hình ảnh minh họa</li>
                  <li>Chia sẻ flashcard công khai</li>
                  <li>Thống kê lượt xem và đánh giá</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlashcardCreator;

